export default __webpack_public_path__ + "static/media/manage-cog-icon.b4ec4a8e.svg";